/**
 * Accordion behavior for .menu-drawer--accordion inside header-drawer.
 * Skips Dawn's slide-panel + submenu-open logic for nested <details>.
 */
(function () {
  const MenuDrawer = customElements.get('menu-drawer');
  if (!MenuDrawer) return;

  const proto = MenuDrawer.prototype;
  const origSummaryClick = proto.onSummaryClick;
  const origCloseSubmenu = proto.closeSubmenu;

  proto.onSummaryClick = function (event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;

    if (detailsElement === this.mainDetailsToggle) {
      return origSummaryClick.call(this, event);
    }

    if (!this.querySelector('.menu-drawer--accordion')) {
      return origSummaryClick.call(this, event);
    }

    setTimeout(() => {
      if (detailsElement.hasAttribute('open')) {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'true');
      } else {
        detailsElement.classList.remove('menu-opening');
        summaryElement.setAttribute('aria-expanded', 'false');
      }
    }, 0);
  };

  proto.closeSubmenu = function (detailsElement) {
    if (this.querySelector('.menu-drawer--accordion')) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      if (parentMenuElement) parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      const summary = detailsElement.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
      detailsElement.removeAttribute('open');
      return;
    }
    return origCloseSubmenu.call(this, detailsElement);
  };
})();
